import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from '../scripts/axiosConfig';
import { AxiosError, isAxiosError } from "axios";

import CLink from '../components/CLink';
import { useMisc } from '../contexts/MiscContext';
import { useAuth } from '../contexts/AuthContext';
import Footer from '../components/Footer';

import "../styles/Contest.scss";

import { IoIosArrowBack } from 'react-icons/io';
import { FiLoader } from "react-icons/fi"; 

import ContestIcon from "../assets/contest.jpg?w=100&h=100&format=webp"

import { toast } from 'react-toastify';
// import CountdownTimer from "react-component-countdown-timer";
import CountdownTimer from '../components/ReactCountdownTimer';
// import "react-component-countdown-timer/lib/styles.css";


const skeletonProblems = {
    SKL1: {
        title: "Problem 1",
        difficulty: "Easy",
        status: ""
    },
    SKL2: {
        title: "Problem 2",
        difficulty: "Medium",
        status: ""
    },
    SKL3: {
        title: "Problem 3",
        difficulty: "Hard",
        status: ""
    }
};  // Skeleton Problems

const difficultyColors = {
    "Easy": "colorGreen",
    "Medium": "colorYellow",
    "Hard": "colorRed"
};


const ToastWithSignIn = () => {
    return (
        <div>
            <div className="toastTitle">
                Login to join the contest.
            </div>
            <div className="toastButtons">
                <button>
                    <CLink to='/login'>Login</CLink>                    
                </button>
            </div>
        </div>
    )
}

const PreviewContest: React.FC = () => {

    const { contestSlug } = useParams<{ contestSlug: string }>();
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const { challengeNameToPageTitle, convertSnakeTagsToTitle } = useMisc();
    const [delayQuery, setDelayQuery] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const [isSuccess, setIsSuccess] = useState(false);

    const [userHasRegistered, setUserHasRegistered] = useState(false);
    const [showJoinButton, setShowJoinButton] = useState(false);
    const [contestStartTime, setContestStartTime] = useState<number>();
    const [buttonLoading, setButtonLoading] = useState(false);

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const raw = params.get('data');

    type DataType = {
        startTime: string;
        endTime: string;
        name: string;
        description: string;
        eventRules: string;
        eventPrizes: string;
        eventTerms: string;
        eventPrivacy: string;
        eventFAQ: string;
        imageURL: string;
        duration: number;
        enableProctored: boolean;
        userHasRegistered: boolean;
        openContestForever: boolean;
        creatorName: string;
        tags: Array<string>;
    };

    let data: DataType | null = null;

    try {
        if (raw) {
            data = JSON.parse(decodeURIComponent(raw));
        } else {
            throw new Error('Invalid data passed in URL');
        }
    } catch (e) {
        console.error('Invalid data passed in URL');
    }

    // const data: DataType = {
    //     startTime: new Date("2023-10-01T00:00:00Z"),
    //     endTime: new Date("2023-10-02T00:00:00Z"),
    //     name: "Test Contest",
    //     description: "This is a test contest",
    //     eventRules: "Event rules",
    //     eventPrizes: "Event prizes",
    //     eventTerms: "Event terms",
    //     eventPrivacy: "Event privacy",
    //     eventFAQ: "Event FAQ",
    //     imageURL: ContestIcon,
    //     duration: 60,
    //     enableProctored: true,
    //     userHasRegistered: false,
    //     openContestForever: false,
    //     creatorName: "Test Creator",
    //     tags: [],
    // }

    useEffect(() => {
        setIsLoading(false);
        setIsSuccess(true);

        console.log("%c State from location: ", "color: orange");
        console.log(location.state);

    }, []);

    useEffect(() => {
        let timer: NodeJS.Timeout | undefined;

        if (data) {
            console.log(data);
            console.log("%c Contest Data Loaded", "color: orange");

            setContestStartTime(new Date(data?.startTime).getTime());
            setUserHasRegistered(data.userHasRegistered);

            let diffBetweenStartTimeAndNow = new Date(data.startTime).getTime() - new Date().getTime()
            // if startTime is in the future, show join button at the time of startTime. 
            if ( new Date(data.startTime) > new Date() ) {
                console.log("Start Time is in the future, setting timer to show join button at startTime.")
                console.log(diffBetweenStartTimeAndNow);
                timer = setTimeout(() => {
                    console.log("Event is Starting!")
                    setShowJoinButton(true);
                    // shows join button
                }, diffBetweenStartTimeAndNow)
            }
            else {
                console.log("Event has already started.")
                if (data?.userHasRegistered || userHasRegistered) {
                    console.log("User has already registered, showing join button.")
                    setShowJoinButton(true);
                }
            }
        }
        
        return () => {
            clearTimeout(timer);
        }
        
    }, [data]);

    const registerForContest = async () => {
        console.log("Registering for Contest");

        setButtonLoading(true);
        let idToken = "";
        if (!currentUser || currentUser === "none") {
            setButtonLoading(false);
            toast.error(ToastWithSignIn, { autoClose: 3000 });
            return;
        }
        else {
            idToken = `Bearer ${await currentUser.getIdToken()}`;
        }

        try {
            const { data } = await axios.post(`/contests/register/${contestSlug}`, {  }, { headers: {
                Authorization: idToken
            } });
            toast.success(data.message);
            console.log("User has registered for the contest!")
            setUserHasRegistered(true);
            setButtonLoading(false);

            console.log(new Date(data.startTime));
            console.log(new Date());

            if ( contestStartTime && (contestStartTime < new Date().getTime()) ) {
                // contest has started already. show join button.
                console.log("Contest has started already. Showing join button...");
                setShowJoinButton(true);
            }
            else {
                console.log("User has registered. But contest hasn't started yet.");
            }
        }
        catch (err: AxiosError | any) {
            toast.error(err.response.data.error || err.message);
        }
        
        setButtonLoading(false);
    }

    const joinContest = async () => {
        console.log("Joining Contest");
        console.log(currentUser)
        setButtonLoading(true);

        let idToken = "";
        if (!currentUser || currentUser === "none") {
            setButtonLoading(false);
            toast.error(ToastWithSignIn, { autoClose: 3000 });
            return;
        }
        else {
            idToken = `Bearer ${await currentUser.getIdToken()}`;
        } 

        console.log(`User's token: ${idToken}`);

        // prefill the basic contest-userdata fields - this will be done when user is redirected to codehouse and /contests/start is invoked.
        // redirect to codehouse
        navigate(`/contests/${contestSlug}/code`);

        setButtonLoading(false);

    }

    const textToShowOnButton = () => {
        if (!currentUser || currentUser === "none") {
            return "Sign In";
        }

        if (buttonLoading) {
            return (
                <div className='loadText'>
                    <div className="rotate">
                        <FiLoader size={"15px"} />
                    </div>
                    <span>Processing</span>
                </div>
            )
        }

        if (data && new Date(data.endTime) < new Date() && !data.openContestForever) {
            return "Contest Ended";
        }

        // if (userHasRegistered) {
        //     return "Registered";
        // }

        // if (data?.emailRestriction === "domain" && currentUser?.email && !data?.emailDomains.includes(currentUser?.email.split("@")[1])) {
        //     return "Not Allowed";
        // }

        // if (data?.emailRestriction === "emails" && currentUser?.email && !data?.allowedEmails.includes(currentUser?.email)) {
        //     return "Not Allowed";
        // }

        return "Register";
    }

    const countdownToShow = () => {
        if (data) {
            console.log("Got data! Determining Countdown to show...");


            if ( (new Date(data?.startTime) < new Date()) && !data.openContestForever && (new Date(data?.endTime) < new Date()) ) {
                return (
                    <div className="ended">
                        Alert! Contest has ended!
                    </div>
                )
            }
            // // if contest has time to start, and user is not registered, show countdown for startTime
            // else if (new Date(data?.startTime) > new Date() && !userHasRegistered) {
            //     console.log("Countdown for startTime");
            //     console.log(`Time diff: ${ (new Date(data?.startTime).getTime() - new Date().getTime()) / 1000 }`)
            //     return (
            //         <div className="countdown">
            //             <div className="title">Starts in</div>
            //             <div className="value">
            //                 <CountdownTimer
            //                     count={  (new Date(data?.startTime).getTime() - new Date().getTime()) / 1000  }
            //                     border
            //                     showTitle
            //                     size={20}
            //                     backgroundColor="transparent"
            //                     color="#000"
            //                     onEnd={() => {
            //                         console.log("Time has ended, contest has started!");
            //                         setShowJoinButton(true);
            //                     }}
            //                 />
            //             </div>
            //         </div>
            //     );
            // }
            // else if contest has time to start, and user is registered, show countdown for starttime
            else if (new Date(data?.startTime) > new Date()) {
                console.log("Countdown for starttime 1");
                console.log(`Time diff: ${(new Date(data?.endTime).getTime() - new Date().getTime()) / 1000}`);
                return (
                    <div className="countdown">
                        <div className="title">Starts in</div>
                        <div className="value">
                            <CountdownTimer
                                count={   (new Date(data?.startTime).getTime() - new Date().getTime()) / 1000  }
                                border
                                showTitle
                                size={20}
                                backgroundColor="transparent"
                                color="#000"
                                onEnd={() => {
                                    console.log("contest has started!");
                                    setShowJoinButton(false);
                                }}
                            />
                        </div>
                    </div>
                );
            }
            // else if contest has time to start, and user is registered, show countdown for endTime
            else if (new Date(data?.startTime) > new Date() && userHasRegistered) {
                console.log("Countdown for endTime 1");
                console.log(`Time diff: ${(new Date(data?.endTime).getTime() - new Date().getTime()) / 1000}`);
                return (
                    <div className="countdown">
                        <div className="title">Ends in</div>
                        <div className="value">
                            <CountdownTimer
                                count={   (new Date(data?.endTime).getTime() - new Date().getTime()) / 1000  }
                                border
                                showTitle
                                size={20}
                                backgroundColor="transparent"
                                color="#000"
                                onEnd={() => {
                                    console.log("Time & contest has ended");
                                    setShowJoinButton(false);
                                }}
                            />
                        </div>
                    </div>
                );
            }
            else if (data?.openContestForever) {
                return (
                    <></>
                )
            }
            // else if contest has started, and user is not registered, show countdown for endTime
            else if (new Date(data?.startTime) < new Date() && !userHasRegistered) {
                console.log("Countdown for endTime 2");
                console.log(`Time diff: ${(new Date(data.endTime).getTime() - new Date().getTime()) / 1000}`);
                return (
                    <div className="countdown">
                        <div className="title">Ends in</div>
                        <div className="value">
                            <CountdownTimer
                                count={(new Date(data?.endTime).getTime() - new Date().getTime()) / 1000}
                                border
                                showTitle
                                size={20}
                                backgroundColor="transparent"
                                color="#000"
                                onEnd={() => {
                                    console.log("Time & CONTEST has ended");
                                    setShowJoinButton(false);
                                }}
                            />
                        </div>
                    </div>
                );
            }

            else if (new Date(data?.startTime) < new Date() && userHasRegistered) {
                console.log("Contest has started and user has registered, showing countdown for endTime");
                console.log(`Time diff: ${(new Date(data.endTime).getTime() - new Date().getTime()) / 1000}`);
                return (
                    <div className="countdown">
                        <div className="title">Ends in</div>
                        <div className="value">
                            <CountdownTimer
                                count={(new Date(data?.endTime).getTime() - new Date().getTime()) / 1000}
                                border
                                showTitle
                                size={20}
                                backgroundColor="transparent"
                                color="#000"
                                onEnd={() => {
                                    console.log("Time & CONTEST has ended");
                                    setShowJoinButton(true);
                                }}
                            />
                        </div>
                    </div>
                );
            }

        }
    }

    const tooltipContent = () => {

        if (!currentUser || currentUser === "none") {
            return "Sign In to join this contest";
        }

        if (data?.endTime && new Date(data.endTime) < new Date() && !data?.openContestForever) {
            return "Contest Ended";
        }

        if (userHasRegistered) {
            return "You have already registered for this contest";
        }

        // if (data?.emailRestriction === "domain" && currentUser?.email && !data?.emailDomains.includes(currentUser?.email.split("@")[1])) {
        //     return "Your email domain is not allowed to join this contest";
        // }

        // if (data?.emailRestriction === "emails" && currentUser?.email && !data?.allowedEmails.includes(currentUser?.email)) {
        //     return "Your email is not allowed to join this contest";
        // }

        return "";
    }

    return (
        <div className='Contest'>
            <Helmet>
                <title>{`${data?.name || contestSlug} - Contest - c0dify`}</title>
            </Helmet>

            <div className="contestContainer">
                
                <div className="contestCoverImage">
                    {
                        (!!(location.state?.from) && !(location?.pathname === location?.state?.from) ) && (
                            <CLink to={location?.state?.from} className="backButton"> <IoIosArrowBack /> </CLink>
                        )
                    }
                    <div className="info">
                        <div className="icon">
                            <img src={data?.imageURL || ContestIcon}/>
                        </div>
                        <div className="text" onDoubleClick={() => console.log(location)} >
                            <div className={("title " + (isLoading && "loading") )}>{data?.name || null}</div>
                            {
                                (data?.creatorName) && (
                                    <div className={("creator " + (isLoading && "loading") )}>{`By ${data?.creatorName}` || null}</div>
                                )
                            }

                            {
                                (isLoading) && (
                                    <div className="tags loading">
                                        <div className="tag loading">please</div>
                                        <div className="tag loading">wait</div>
                                        <div className="tag loading">loading</div>
                                    </div>
                                )
                            }
                            {
                                (isSuccess && data && data.tags?.length > 0) && (
                                    <div className="tags">
                                        {
                                            data?.tags.map((tag: string, index: number) => {
                                                return (
                                                    <CLink 
                                                        to={`/tags/${tag}`} 
                                                        className={`tag ${tag}`} 
                                                        key={index}>
                                                            {convertSnakeTagsToTitle(tag)}
                                                    </CLink>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            }
                            
                        </div>
                    </div>
                </div>


                <div className="contestInfo">
                    
                    <div className="infoContainer">
                        <div className="leftSection">

                            <div className="row">
                                {countdownToShow()}
                            </div>

                            <div className={("row about " + (isLoading && "loading") )}>
                                <div className="title">
                                    About the Event
                                </div>
                                <div className="value">
                                    {data?.description}
                                </div>
                            </div>

                            <div className={("row " + (isLoading && "loading") )}>
                                <div className="title">
                                    Event Rules
                                </div>
                                <div className="value">
                                    {data?.eventRules}
                                </div>
                            </div>

                            <div className={("row " + (isLoading && "loading") )}>
                                <div className="title">
                                     Event Prizes
                                </div>
                                <div className="value">
                                    {data?.eventPrizes}
                                </div>
                            </div>

                            <div className={("row " + (isLoading && "loading") )}>
                                <div className="title">
                                    Event Terms and Conditions
                                </div>
                                <div className="value">
                                    {data?.eventTerms}
                                </div>
                            </div>

                            <div className={("row " + (isLoading && "loading") )}>
                                <div className="title">
                                    Event Privacy Policy
                                </div>
                                <div className="value">
                                    {data?.eventPrivacy}
                                </div>
                            </div>

                            <div className={("row " + (isLoading && "loading") )}>
                                <div className="title">
                                    Event FAQ
                                </div>
                                <div className="value">
                                    {data?.eventFAQ}
                                </div>
                            </div>

                        </div>
                        <div className="rightSection">
                            <div className="buttonsContainer">
                                {
                                    (data && !showJoinButton) && (
                                        <button onClick={registerForContest} 
                                        disabled={
                                            buttonLoading ||
                                            data?.userHasRegistered ||
                                            userHasRegistered ||
                                            (new Date(data?.endTime) < new Date() && !data?.openContestForever)
                                            // (data?.emailRestriction === "domain" && currentUser?.email && !data?.emailDomains.includes(currentUser?.email.split("@")[1])) ||
                                            // (data?.emailRestriction === "emails" && currentUser?.email && !data?.allowedEmails.includes(currentUser?.email))
                                        }
                                        data-tooltip-id="tt" 
                                        data-tooltip-content={tooltipContent()}
                                        >
                                            {textToShowOnButton()}
                                        </button>
                                    )
                                }
                                {
                                    (data && userHasRegistered && showJoinButton && (data.openContestForever || (new Date(data.endTime) > new Date()))) && (
                                        <button
                                            onClick={joinContest}
                                            data-tooltip-id="tt"
                                            data-tooltip-content={tooltipContent()}
                                        >
                                            Join the Contest!
                                        </button>
                                    )
                                }
                                {/* {
                                    ( (new Date(data?.startTime) < new Date()) && !data.openContestForever && (new Date(data?.endTime) < new Date())) && (
                                        <button 
                                            disabled
                                            data-tooltip-id='tt'
                                            data-tooltip-content={"Contest has ended already."}
                                        >
                                            Ended
                                        </button>
                                    )
                                } */}
                                

                                <div className="infoRows">
                                    <div className={("row " + (isLoading && "loading") )}>
                                        <div className="title">Starts</div>
                                        <div className="value">{data?.startTime ? new Date(data.startTime).toLocaleString() : 'N/A'}</div>
                                    </div>
                                    <div className={("row " + (isLoading && "loading") )}>
                                        <div className="title">Ends</div>
                                        <div className="value">{ (data?.openContestForever) ? 'Never' : new Date(data?.endTime || '').toLocaleString()}</div>
                                    </div>
                                    <div className={("row " + (isLoading && "loading") )}>
                                        <div className="title">Duration</div>
                                        <div className="value">{!data?.duration ? `Unlimited` : `${data?.duration} minutes`}</div>
                                    </div>
                                    <div className={("row " + (isLoading && "loading") )}>
                                        <div className="title">Proctored Mode</div>
                                        <div className="value">{data?.enableProctored ? "Yes" : "No"}</div>
                                    </div>

                                    <div className="splitter"></div>

                                    <div className="row">
                                        <div className={("link " + (isLoading && "loading") )}>
                                            <CLink to={`/leaderboard/${contestSlug}`}>
                                                Leaderboard
                                            </CLink>
                                        </div>
                                        {/* <div className={("link " + (isLoading && "loading") )}>
                                            <CLink to={`/submissions/${contestSlug}`}>
                                                Submissions
                                            </CLink>
                                        </div> */}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <Footer />

        </div>
    );
};

export default PreviewContest;